module.exports = __webpack_public_path__ + "static/radboud-logo-white-1014f511fcfa5efa40a75fedd7fac6c3.svg";